<template>
  <div id="app">
    <index-loader v-if="isLoading" />
    <router-view v-else />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'App',
  setup() {
    const authStore = useAuthStore()
    const isLoading = ref(true)

    onMounted(async () => {
      try {
        // Initialize auth state from localStorage
        // This is also done in router guard, but we do it here
        // to show loading state while initializing
        if (!authStore.isInitialized) {
          await authStore.initialize()
        }
      } catch (error) {
        console.error('App initialization error:', error)
      } finally {
        // Small delay to prevent flash
        setTimeout(() => {
          isLoading.value = false
        }, 100)
      }
    })

    return {
      isLoading
    }
  }
}
</script>

<style>
/* Page wrapper styles */
.page-wrapper {
  margin-left: 240px;
  padding-top: 60px;
  min-height: 100vh;
  transition: all 0.2s ease-in-out;
}

.mini-sidebar .page-wrapper {
  margin-left: 60px;
}

@media (max-width: 991px) {
  .page-wrapper {
    margin-left: 0;
  }
}

.content {
  padding: 25px;
}
</style>
